import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Logo from '../../images/Logo/logo-white.png';

const NAV_LINKS = [
    { label: 'Home', to: '/' },
    { label: 'Products', to: '/products' },
    { label: 'Request a Product', to: '/request' },
    { label: 'Contact Us', to: '/contact' },
];

const Footer = () => {
    const [data, setData] = useState({});

    const scrollTop = () => window.scrollTo(0, 0);

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_BASE_URL + '/socials')
            .then(r => {
                if (r.data && r.data[0]) {
                    const { _id, updatedAt, ...links } = r.data[0];
                    setData(links);
                }
            })
            .catch(() => {});
    }, []);

    const address = data['address'] || 'Ireland';
    const email   = data['gmail']   || 'info@deepprabha.ie';
    const mapsUrl = `https://maps.google.com/?q=${encodeURIComponent(address)}`;
    // phones is an array; each element may contain comma-separated numbers
    const phones  = (data['phones'] || [])
        .flatMap(p => p.split(','))
        .map(p => p.trim())
        .filter(Boolean);

    return (
        <footer className="dp-footer">
            {/* Top wave */}
            <div className="dp-footer__wave">
                <svg viewBox="0 0 1440 60" preserveAspectRatio="none">
                    <path d="M0,30 C480,60 960,0 1440,30 L1440,0 L0,0 Z" fill="#f4f6fb" />
                </svg>
            </div>

            <div className="dp-footer__body">
                <div className="dp-footer__inner">

                    {/* Brand col */}
                    <div className="dp-footer__col dp-footer__col--brand">
                        <Link to="/" onClick={scrollTop} className="dp-footer__logo">
                            <img src={Logo} alt="Deep Prabha Transchem" />
                        </Link>
                        <p className="dp-footer__tagline">
                            Your trusted partner for industrial chemicals and specialty compounds — delivered globally with precision and care.
                        </p>
                        <div className="dp-footer__socials">
                            {data['facebook'] && (
                                <a href={data['facebook']} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                                </a>
                            )}
                            {data['linkedin'] && (
                                <a href={data['linkedin']} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
                                </a>
                            )}
                            {data['twitter'] && (
                                <a href={data['twitter']} target="_blank" rel="noopener noreferrer" aria-label="Twitter / X">
                                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/></svg>
                                </a>
                            )}
                            {data['instagram'] && (
                                <a href={data['instagram']} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
                                </a>
                            )}
                            {data['youtube'] && (
                                <a href={data['youtube']} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#0c3969"/></svg>
                                </a>
                            )}
                            {data['whatsapp'] && (
                                <a href={`https://wa.me/${data['whatsapp'].replace(/\D/g,'')}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                                    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
                                </a>
                            )}
                        </div>
                    </div>

                    {/* Quick links */}
                    <div className="dp-footer__col">
                        <h4 className="dp-footer__col-title">Quick Links</h4>
                        <ul className="dp-footer__links">
                            {NAV_LINKS.map(l => (
                                <li key={l.to}>
                                    <Link to={l.to} onClick={scrollTop}>
                                        <span>→</span> {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="dp-footer__col">
                        <h4 className="dp-footer__col-title">Contact Us</h4>
                        <ul className="dp-footer__contact">
                            <li>
                                <span className="dp-footer__contact-icon">📍</span>
                                <a href={mapsUrl} target="_blank" rel="noopener noreferrer">{address}</a>
                            </li>
                            <li>
                                <span className="dp-footer__contact-icon">✉️</span>
                                <a href={`mailto:${email}`}>{email}</a>
                            </li>
                            {phones.length > 0 && (
                                <li>
                                    <span className="dp-footer__contact-icon">📞</span>
                                    <span>
                                        {phones.map((ph, i) => (
                                            <React.Fragment key={i}>
                                                <a href={`tel:${ph.replace(/\s/g,'')}`}>{ph}</a>
                                                {i < phones.length - 1 && ', '}
                                            </React.Fragment>
                                        ))}
                                    </span>
                                </li>
                            )}
                            {data['whatsapp'] && (
                                <li>
                                    <span className="dp-footer__contact-icon">💬</span>
                                    <a href={`https://wa.me/${data['whatsapp'].replace(/\D/g,'')}`} target="_blank" rel="noopener noreferrer">WhatsApp Us</a>
                                </li>
                            )}
                        </ul>
                    </div>

                </div>

                {/* Divider */}
                <div className="dp-footer__divider" />

                {/* Bottom bar */}
                <div className="dp-footer__bottom">
                    <p>© {new Date().getFullYear()} <Link to="/" onClick={scrollTop}>Deep Prabha Transchem</Link>. All Rights Reserved.</p>
                    <p>Developed by <a href="https://ideaspoint.in/" target="_blank" rel="noopener noreferrer">IdeasPoint</a></p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
